module.exports = __webpack_public_path__ + "img/kkb_steelflex.f158403f.jpg";